import { ComponentType, FC } from "preact/compat";
import { IconProps } from "./interfaces";
import AssignmentIcon from "@material-design-icons/svg/outlined/assignment.svg";
import MagicIcon from "@material-design-icons/svg/outlined/auto_fix_high.svg";
import BackHandIcon from "@material-design-icons/svg/outlined/back_hand.svg";
import CalendarMonthIcon from "@material-design-icons/svg/outlined/calendar_month.svg";
import ChevronLeftIcon from "@material-design-icons/svg/outlined/chevron_left.svg";
import ChevronRightIcon from "@material-design-icons/svg/outlined/chevron_right.svg";
import EditIcon from "@material-design-icons/svg/outlined/edit.svg";
import HomeIcon from "@material-design-icons/svg/outlined/home.svg";
import LinkIcon from "@material-design-icons/svg/outlined/link.svg";
import MoreVertIcon from "@material-design-icons/svg/outlined/more_vert.svg";
import PersonIcon from "@material-design-icons/svg/outlined/person.svg";
import QuestionMarkIcon from "@material-design-icons/svg/outlined/question_mark.svg";
import SearchIcon from "@material-design-icons/svg/outlined/search.svg";
import SettingsIcon from "@material-design-icons/svg/outlined/settings.svg";
import TimerIcon from "@material-design-icons/svg/outlined/timer.svg";
import ViewTimelineIcon from "@material-design-icons/svg/outlined/view_timeline.svg";
import WarningIcon from "@material-design-icons/svg/outlined/warning.svg";
import cn from "classnames";

const ICONS: Partial<
    Record<string, ComponentType<React.HTMLAttributes<SVGSVGElement>>>
> = {
    "question-mark": QuestionMarkIcon,
    person: PersonIcon,
    home: HomeIcon,
    "chevron-right": ChevronRightIcon,
    "chevron-left": ChevronLeftIcon,
    timer: TimerIcon,
    "back-hand": BackHandIcon,
    "more-vert": MoreVertIcon,
    search: SearchIcon,
    "view-timeline": ViewTimelineIcon,
    assignment: AssignmentIcon,
    "calendar-month": CalendarMonthIcon,
    link: LinkIcon,
    settings: SettingsIcon,
    magic: MagicIcon,
    warning: WarningIcon,
    edit: EditIcon,
};

const Icon: FC<IconProps> = ({ name, size, fill }) => {
    if (!name) {
        return null;
    }

    const key = name
        .split(" ")
        .map((value) => value.toLowerCase())
        .join("-");

    const Comp = ICONS[key];

    if (!Comp) {
        return null;
    }

    return (
        <Comp
            style={{ fill }}
            className={cn("d-icon", size === "lg" && "lg")}
        />
    );
};

export default Icon;
